import { InjectionToken } from '@angular/core';

/* common interface for components that allow dynamic fields between static content */
export const COMPONENT_BASE = new InjectionToken<object>( 'IComponentBase' );
